(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-shoppable-video"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(scope) {
    var root = scope || document;
    // variant panel toggle
    root.querySelectorAll('.ssv [data-ssv-toggle]').forEach(function (btn) {
      if (btn.dataset.b) return; btn.dataset.b = '1';
      btn.addEventListener('click', function () {
        var form = btn.closest('[data-ssv-buy]');
        var open = form.hasAttribute('data-ssv-open');
        if (open) { form.removeAttribute('data-ssv-open'); btn.setAttribute('aria-expanded', 'false'); }
        else { form.setAttribute('data-ssv-open', ''); btn.setAttribute('aria-expanded', 'true'); }
      });
    });
    // carousel arrows
    root.querySelectorAll('.ssv').forEach(function (sec) {
      var track = sec.querySelector('[data-ssv-track]');
      if (!track) return;
      var prev = sec.querySelector('[data-ssv-prev]');
      var next = sec.querySelector('[data-ssv-next]');
      var step = function () {
        var card = track.querySelector('.ssv__card');
        return card ? card.getBoundingClientRect().width + 16 : 300;
      };
      if (prev && !prev.dataset.b) { prev.dataset.b = '1'; prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); }); }
      if (next && !next.dataset.b) { next.dataset.b = '1'; next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); }); }
    });
    // sound toggle (only one video plays with audio at a time)
    root.querySelectorAll('.ssv [data-ssv-sound]').forEach(function (btn) {
      if (btn.dataset.b) return; btn.dataset.b = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var media = btn.closest('.ssv__media');
        var video = media && media.querySelector('.ssv__video');
        if (!video) return;
        var turningOn = video.muted;
        document.querySelectorAll('.ssv__video').forEach(function (v) {
          if (v !== video) v.muted = true;
        });
        document.querySelectorAll('.ssv [data-ssv-sound][aria-pressed="true"]').forEach(function (b) {
          if (b !== btn) b.setAttribute('aria-pressed', 'false');
        });
        video.muted = !turningOn;
        btn.setAttribute('aria-pressed', turningOn ? 'true' : 'false');
        btn.setAttribute('aria-label', turningOn ? 'Desativar som' : 'Ativar som');
      });
    });
    // posters ficam em data-poster (fora do preload scanner); aplica com
    // rootMargin de 2 telas para o thumb estar pronto antes do card aparecer
    var lazyPosters = root.querySelectorAll('.ssv__video[data-poster]');
    if (lazyPosters.length) {
      var applyPoster = function (v) {
        if (v.dataset.poster) { v.poster = v.dataset.poster; delete v.dataset.poster; }
      };
      if ('IntersectionObserver' in window) {
        var pio = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            applyPoster(e.target);
            pio.unobserve(e.target);
          });
        }, { rootMargin: '200% 100%' });
        lazyPosters.forEach(function (v) { pio.observe(v); });
      } else {
        lazyPosters.forEach(applyPoster);
      }
    }
    // play only visible videos (perf)
    var vids = root.querySelectorAll('.ssv__video');
    if (vids.length && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function(){}); }
          else { v.pause(); }
        });
      }, { threshold: 0.25 });
      vids.forEach(function (v) { io.observe(v); });
    }
  }
  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
